import React from 'react';
import { createPortal } from 'react-dom';

/**
 * Simple reusable Modal component.
 */
function Modal({ isOpen, onClose, title, children, inline = false, containerClassName = '' }) {
    if (!isOpen) return null;

    if (inline) {
        return (
            <div className={`bg-white p-6 rounded-lg shadow-sm border border-gray-200 w-full ${containerClassName}`}>
                <div className="flex justify-between items-center mb-4 border-b pb-2">
                    <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
                    {onClose && (
                        <button
                            onClick={onClose}
                            className="text-gray-500 hover:text-gray-700 text-2xl leading-none"
                            aria-label="Close"
                        >
                            &times;
                        </button>
                    )}
                </div>
                <div>{children}</div>
            </div>
        );
    }

    return createPortal(
        // Outer div for backdrop and centering
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4">
            {/* Modal content container */}
            <div className={`bg-white p-6 rounded-lg shadow-xl w-full mx-4 overflow-y-auto ${containerClassName || 'max-w-4xl max-h-[80vh]'}`}>
                {/* Modal header */}
                <div className="flex justify-between items-center mb-4 border-b pb-2">
                    <h2 className="text-xl font-semibold text-gray-800">{title}</h2>
                    {/* Close button */}
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 text-2xl leading-none"
                        aria-label="Close modal"
                    >
                        &times;
                    </button>
                </div>
                {/* Modal body */}
                <div>{children}</div>
            </div>
        </div>,
        document.body
    );
}

export default Modal;
